<template>
  <div class="container">
      <section class="hero is-medium is-light is-bold">
    <div class="hero-body">
      <div class="container">
        <h2 class="subtitle"><b>お問い合わせ</b></h2>
        <h1 class="title">
          <a href="mailto:address">support-sx-score@sxi.co.jp</a><br>
        </h1>
        <p>受付時間：10:00～18:00（土曜・日曜・祝日、年末年始を除く）</p>
      </div>
    </div>
  </section>
  </div>
</template>

<script>
export default {
  name: 'Inquiry'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Inquiry.vue